(function(angular, _, $) {
    'use strict';

    /**
     * @todo Moved into a component FS structure. Full code refactoring required.
     */

    /**
     * @ngdoc object
     * @name ActivateGroupedFilterController
     * @description Controller for the analysis chart handler
     */
    class ActivateGroupedFilterController {
        static get $inject() {
            return ['$scope'];
        }

        constructor($scope) {
            this.$scope = $scope;
        }

        $onInit() {
            // Guarantees that the scope soup will survive for now
            this.$scope.analysisId = this.analysisId;
            this.$scope.messageSuffix = this.messageSuffix;
            this.$scope.onComplexFilterApply = this.onComplexFilterApply;
        }

        $onChanges(changeList) {
            if (_.get(changeList, 'buildComponent.currentValue') && !changeList.buildComponent.isFirstChange()) {
                this.$scope.buildFilterEngine();
            }
        }
    }

    angular.module('wtApp.wtFilterEngine')
        .directive('activateGroupedFilter', ['$injector', function($injector) {
            const $compile = $injector.get('$compile');

            return {
                restrict: 'EA',
                replace: true,
                controller: ActivateGroupedFilterController,
                controllerAs: '$filterEngine',
                bindToController: true,
                scope: {
                    analysisId: '<',
                    standAlone: '<?',
                    messageSuffix: '<?',
                    buildComponent: '<?',
                    onComplexFilterApply: '&?'
                },
                link: function($scope, $element, $attrs, $filterEngine) {
                    const GFL_CONST = $injector.get('GFL_CONST');
                    const filterUtils = $injector.get('filterUtils');
                    const configService = $injector.get('configService');
                    const segmentService = $injector.get('segmentService');
                    const requestObjectFactory = $injector.get('requestObjectFactory');
                    const activateGroupedFilterService = $injector.get('activateGroupedFilterService');
                    const userService = $injector.get('userService');
                    const featureFlagService = $injector.get('featureFlagService');

                    let newElement;

                    let messageSuffix = '';
                    if (!_.isEmpty($scope.messageSuffix)) {
                        messageSuffix = $scope.messageSuffix;
                    } else if (!_.isEmpty($scope.$parent.messageSuffix)) {
                        messageSuffix = $scope.$parent.messageSuffix;
                    }

                    if (!$scope.analysisId) {
                        return;
                    }

                    const analysis = configService.getAnalysis($scope.analysisId);
                    const layer = configService.getAnalysisLayer($scope.analysisId);

                    $scope.forceComplexFilter = $attrs.forceComplexFilter === 'true';
                    $scope.nestedFilterElementReferences = [];
                    $scope.destroyNestedFilterElements = function() {
                        _.each($scope.nestedFilterElementReferences, function(nestedFilter) {
                            if (nestedFilter) {
                                if (nestedFilter.isolateScope()) {
                                    nestedFilter.isolateScope().$destroy();
                                }
                                nestedFilter.remove();
                            }
                        });
                        $scope.nestedFilterElementReferences = [];
                    };
                    $scope.onModalOpenClick = function() {
                        $('#stage').trigger('collapse-menus');
                    };

                    /**
                     * Will aplly the filters on an analysis
                     * @param  {Array=}  modalContainers Optional list of containers as returned from the complex-filter-modal
                     */
                    $scope.applyFilter = function(modalContainers = []) {
                        // Before cleaning empty containers determine if we have any containers at all. When triggered from modal at least
                        // one empty container should be present. On the contrary when triggered from the simple filter the list of containers will be empty
                        var isCalledFromModal = !_.isEmpty(modalContainers);
                        $scope.filterContainers = [];
                        filterUtils.cleanContainerListFilterDuplicates(modalContainers, ['arrangeType', 'value1', 'value2', 'filterPredicate', 'context', 'connector']);
                        filterUtils.cleanEmptyContainers(modalContainers);
                        if (!_.isEmpty(modalContainers)) {
                            $scope.normalFilter = [];
                            _.forEach(modalContainers, function(container) {
                                if (container.context && container.context === GFL_CONST.NORMAL_FILTER_CONTEXT_NAME) {
                                    $scope.normalFilter = container.filters;
                                } else {
                                    // not AUTO containers shall not have a time-filter
                                    _.remove(container.filters, function(filter) {
                                        return _.includes(GFL_CONST.TIME_FILTER_ARRANGE_TYPES, filter.arrangeType);
                                    });
                                    var newContainer = {
                                        containers: container.containers,
                                        filters: container.filters,
                                        connector: container.connector || 'AND',
                                        context: container.context,
                                        type: container.type
                                    };
                                    if (!_.isUndefined(container.combined) && container.combined) {
                                        newContainer.combined = true;
                                    }
                                    newContainer[GFL_CONST.CONTAINER_PREDICATE_ATTRIBUTE]
                                        = container[GFL_CONST.CONTAINER_PREDICATE_ATTRIBUTE] || 'IN';
                                    $scope.filterContainers.push(newContainer);
                                }
                            });
                        } else if (isCalledFromModal) {
                            $scope.resetFilter();
                        }

                        activateGroupedFilterService.addTimeFilter($scope.analysisId, $scope.normalFilter);

                        var filterEngineListCopy = _.cloneDeep($scope.normalFilter);
                        // Should iterate over filters and populate the filterContainers as well
                        var fakeSegmentArrangeType = segmentService.getFakeSegmentArrangeType();
                        var segmentsUsed = [];
                        var newFilters = _.filter(filterEngineListCopy, function(filterObj, filterObjIndex) {
                            if (filterObj.arrangeType === fakeSegmentArrangeType) {
                                var tempSegment = segmentService.getActiveSegmentById(filterObj.value1);
                                segmentsUsed.push({
                                    id: filterObj.value1,
                                    position: filterObjIndex
                                });
                                // Only include segments that have a set filter property AND have a non empty value1 (exclude Nones)
                                if (tempSegment && tempSegment.filter && !_.isEmpty(filterObj.value1)) {
                                    var tempContainer = _.cloneDeep(tempSegment.filter);
                                    tempContainer.connector = filterObj.connector;
                                    tempContainer.context = filterObj.context;
                                    tempContainer[GFL_CONST.CONTAINER_PREDICATE_ATTRIBUTE] = filterObj.filterPredicate === 'LIKE' ? 'IN' : 'NOT_IN';
                                    tempContainer.isSegment = true;
                                    tempContainer.segmentId = parseInt(filterObj.value1);
                                    $scope.filterContainers.push(tempContainer);
                                }
                            }
                            delete filterObj.mapping;
                            delete filterEngineListCopy[filterObjIndex].mapping;
                            if (_.isEmpty(filterObj.value1)) {
                                filterEngineListCopy[filterObjIndex] = null;
                            }
                            return !_.isEmpty(filterObj.value1) && filterObj.arrangeType !== fakeSegmentArrangeType;
                        });
                        $scope.latestRequestQuery.filters = (function(clonedFilters) {
                            filterUtils.omitFilterProperties(clonedFilters, ['sequential', 'id']);
                            return clonedFilters;
                        })(_.cloneDeep(newFilters));
                        // save the segments for the save bookmark feature
                        // since segments are resolved to filters, there would be no other save way
                        // to find out which segments are currently active
                        segmentService.setSegmentsByAnalysisId(segmentsUsed, $scope.analysisId);
                        //  Clean last queries from null values and cache them
                        segmentService.setFilterQueryByAnalysisId(
                            $scope.analysisId,
                            filterUtils.omitFilterProperties(_.cloneDeep($scope.normalFilter), ['sequential', 'id'])
                        );
                        // Fire filter requests only when the new filter requested has changed since the last request.
                        const queryHasChanged = activateGroupedFilterService.hasChangedQuery(
                            $scope.analysisId,
                            newFilters,
                            $scope.filterContainers
                        );

                        if (queryHasChanged) {
                            requestObjectFactory.emptyAnalysisFilterById($scope.analysisId);
                            requestObjectFactory.emptyAnalysisContainersById($scope.analysisId);
                            filterUtils.omitFilterProperties(newFilters, ['sequential', 'id']);
                            filterUtils.omitFilterProperties($scope.filterContainers, ['sequential', 'id', 'internalObject', 'mapping']);

                            const segmentConnections = segmentService.getSegmentConnectorsFromContainers($scope.filterContainers);
                            const predefinedContainer = {
                                filters: filterUtils.getTimelessFilterList(newFilters),
                                containers: filterUtils.normalizeContainerList(_.filter($scope.filterContainers, function(iContainer) {
                                    return !iContainer.isSegment;
                                }))
                            };

                            if (isCalledFromModal) {
                                if (_.isFunction($scope.onComplexFilterApply)) {
                                    $scope.onComplexFilterApply();
                                }
                                analysis.activateRequestLock().buildEmptyResponse();
                            }

                            const reload = _.get($scope, 'standAlone', true);
                            analysis.setSegmentConnectionsAndContainers(segmentConnections, predefinedContainer, true, reload);
                        }
                    };
                    $scope.containers = [];
                    $scope.containersBackup = [];
                    $scope.resetFilter = function() {
                        $scope.containers = [];
                        $scope.containersBackup = [];
                        // Removes all filters apart from internalObject and time range filters
                        _.remove($scope.normalFilter, function(filter) {
                            if ($injector.get('Filters').isTime(filter)) {
                                return false;
                            }

                            return !filter.internalObject;
                        });
                    };

                    const setMainDimension = () => {
                        // Fetch the main column configuration from the proper Monads
                        $scope.mainColumnDimension = activateGroupedFilterService.getMainColumnDimension($scope.analysisId);
                    };

                    $scope.buildFilterEngine = () => {
                        $scope.allMetrics = activateGroupedFilterService.filterMetricsByColumns($scope.analysisId);
                        $scope.allDimensions = activateGroupedFilterService.filterDimensionsByColumns($scope.analysisId);
                        $scope.latestRequestQuery = activateGroupedFilterService.getLatestQuery($scope.analysisId);
                        // @todo: Following lines keep the filter in sync for TS. Needs to go, but needs major rework with caching.
                        const bySegment = _.cloneDeep(filterUtils.getTimelessFilterList(segmentService.getFilterQueryByAnalysisId($scope.analysisId)));

                        $scope.normalFilter = _.chain($scope.latestRequestQuery)
                                                .get('filters')
                                                .union(bySegment)
                                                .uniqBy(filter => {
                                                    if (filter.internalObject === false) {
                                                        delete filter.internalObject;
                                                    }
                                                    delete filter.mapping;
                                                    return JSON.stringify(filter);
                                                })
                                                .forEach(filter => {
                                                    activateGroupedFilterService
                                                        .addIds(filter)
                                                        .removeMapping(filter);
                                                })
                                                .value();

                        $scope.containers = _.chain($scope.latestRequestQuery)
                                                .get('containers')
                                                .reject({isSegment: true})
                                                .cloneDeep()
                                                .forEach(container => {
                                                    activateGroupedFilterService
                                                        .addIds(container.filters)
                                                        .removeMapping(container.filters)
                                                        .setSequential(container);
                                                })
                                                .value();

                        $scope.segments = _.chain($scope.latestRequestQuery)
                                            .get('containers')
                                            .filter({isSegment: true})
                                            .cloneDeep()
                                            .forEach(container => {
                                                activateGroupedFilterService
                                                    .addIds(container.filters)
                                                    .removeMapping(container.filters)
                                                    .setSequential(container);
                                            })
                                            .value();

                        // Inject the segments as filters
                        activateGroupedFilterService
                                .injectSegments($scope.analysisId, $scope.normalFilter, $scope.segments)
                                .removeDuplicates($scope.normalFilter)
                                .sortByPosition($scope.normalFilter)
                                .timeFilterFirst($scope.normalFilter);

                        //                    only if there are containers the normal filter should be present in containers as well
                        const hasValidFilter = _.find($scope.normalFilter, function(filter) {
                            return !filter.internalObject && !_.isEmpty(filter.value1);
                        });

                        //@todo: See internalObject filters creeping in via containers
                        if ($scope.containers && $scope.containers.length > 0
                                && $scope.normalFilter && $scope.normalFilter.length > 1
                                && hasValidFilter) {
                            $scope.containers.unshift({
                                connector: 'AND',
                                context: GFL_CONST.NORMAL_FILTER_CONTEXT_NAME,
                                filters: $scope.normalFilter
                            });
                        }
                        // Hash of filter properties relevant only to the frontend. The hash is filter id based.
                        $scope.filterSetMeta = {};

                        setMainDimension();

                        //@todo: Even though some sucker wants actually to delete them...
                        _.remove($scope.normalFilter, function(filter) {
                            filter.value1 = String(filter.value1);
                            return _.isEmpty(filter.value1) && !filter.internalObject;
                        });
                        $scope.lang = userService.getLanguage();
                        $scope.featureFlags = featureFlagService.getFeaturesFlags();
                        $scope.aggregates = activateGroupedFilterService.getAggregates($scope.analysisId);

                        if (newElement) {
                            return;
                        }

                        var template = '<div class="analysis-filter-wrap" analysis-filter force-complex-filter="forceComplexFilter" '
                            + ' filter-language="lang" '
                            + ' all-metrics="allMetrics" '
                            + ' all-dimensions="allDimensions"'
                            + ' apply-filter="applyFilter" '
                            + ' containers="containers" '
                            + ' containers-backup="containersBackup" '
                            + ' filter-set="normalFilter" '
                            + ' filter-set-meta="filterSetMeta"'
                            + ' main-column-dimension="mainColumnDimension"'
                            + ' on-modal-open="onModalOpenClick" '
                            + ' feature-flags="featureFlags" '
                            + ' on-complex-filter-apply="onComplexFilterApply()" '
                            + ` data-layer="${layer}"`
                            + ' aggregates="aggregates"'
                            + ' reset-filter="resetFilter"></div>';
                        newElement = angular.element(template);
                        $scope.destroyNestedFilterElements();
                        $scope.nestedFilterElementReferences.push(newElement);
                        $compile(newElement)($scope);
                        $element.empty().append(newElement);
                    };

                    $scope.$on(`analysisLoaded${messageSuffix}`, $scope.buildFilterEngine);

                    const observers = {};

                    const buildEmptyFilter_ = (emptyResponse) => {
                        if (!emptyResponse) {
                            return;
                        }

                        _.extend($scope, emptyResponse);
                        $scope.buildFilterEngine();
                    };

                    //@todo: Ought be gone and stay gone once the filter engine is refactored. Component
                    // should build on init and not waiting on some analysis loaded event.
                    if (_.get($filterEngine, 'buildComponent')) {
                        $scope.buildFilterEngine();
                    }

                    buildEmptyFilter_(analysis.latestEmptyResponse);
                    observers.onEmptyResponse = analysis.changesOfType('EMPTY_RESPONSE_GENERATED').subscribe((changes) => buildEmptyFilter_(_.get(changes, 'payload.emptyResponse')));

                    observers.onDimensionReorder = analysis.columns.changesOfType('DIMENSION_COLUMNS_REORDERED').subscribe(setMainDimension);

                    $scope.$on('$destroy', function() {
                        newElement = null;
                        _.forEach(observers, (observer) => observer.unsubscribe());
                        $scope.destroyNestedFilterElements();
                        $scope.nestedFilterElementReferences = null;
                        $scope.onModalOpenClick = null;
                        $scope.containers = null;
                        $scope.containersBackup = null;
                        $scope.resetFilter = null;
                        $scope.latestRequestQuery = null;
                        $scope.normalFilter = null;
                        $scope.filterContainers = null;
                        $scope.applyFilter = null;
                    });
                }
            };
        }]);
})(window.angular, window._, window.$);
